module.exports = __webpack_public_path__ + "static/media/miami-11.829e0bd4.jpg";